import type { CheckboxTreeGroupProps } from './CheckboxTreeGroup';

// TODO: Type the keys of this as CheckboxSize
export const SIZE_TO_VERTICAL_SPACING_MAP: Record<string, string> = {
  lg: '0.75rem',
  md: '0.5rem',
  sm: '0.25rem',
};

// TODO: Type the keys of this as CheckboxSize
export const SIZE_TO_HORIZONTAL_SPACING_MAP: Record<string, string> = {
  lg: '1rem',
  md: '1rem',
  sm: '0.75rem',
};

// Margin left on the child stack for when the group has a parent.
// TODO: Type the keys of this as CheckboxSize
export const SIZE_TO_STACK_MARGIN_MAP: Record<string, string> = {
  lg: '1.75rem',
  md: '1.5rem',
  sm: '1.125rem',
};

export const DEFAULT_PROPS = {
  size: 'md',
  direction: 'column',
} as const satisfies CheckboxTreeGroupProps;
